module.exports = __webpack_public_path__ + "static/secretariat-77a24e8c4427ef84f2ffd35b7240167e.svg";